import { Component, OnInit, Input } from '@angular/core';
import { Bracket, DataService, BracketRound } from 'src/app/services/data-service.service';

@Component({
  selector: 'bracket',
  templateUrl: './bracket.component.html',
  styleUrls: ['./bracket.component.scss']
})
export class BracketComponent implements OnInit {
  @Input() bracket: Bracket;

  public rounds: BracketRound[] = [];

  constructor(public ds: DataService) { }

  ngOnInit(): void {
    this.rounds = this.bracket.rounds.filter(r => r.roundNum > 0);
    this.rounds.forEach(r => {
      r.matches.sort((a, b) => a.pitchNum < b.pitchNum ? -1 : 1);
      r.matches[0].showHeaders = true;
    });
  }
}
